import {
  Box,
  Button,
  Paper,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { useContext, useEffect, useState } from "react";
import DevTeamRow from "./DevTeamRow";
import { getDevTeams } from "../../../../api/settings";
import { useAuth0 } from "@auth0/auth0-react";
import AddDevTeamRow from "./AddDevTeamRow";
import SyncContext from "../../../../context/SyncContext";


interface DevTeamsProps {
  _id?: string;
  name?: string;
  description?: string;
  setProductAreaLoadPage: any;
  producAreaLoadPage: boolean;
  loadDevTeams: boolean;
  setLoadDevTeams: any;
}
function DevTeam({
  producAreaLoadPage,
  setProductAreaLoadPage,
  loadDevTeams,
  setLoadDevTeams
}: DevTeamsProps) {
  const auth0 = useAuth0();
  const [devTeams, setDevTeams] = useState<DevTeamsProps[]>([]);
  const [addDevTeamIsOpen, setAddDevTeamIsOpen] = useState(false);
  const [loadPage, setLoadPage] = useState(false);
  const { owners } = useContext(SyncContext)


  const getDevTeam = async () => {
    await getDevTeams(auth0).then((res) => {
      setDevTeams(res.teams);
    });
  };
  useEffect(()=>{
    getDevTeam();
  },[addDevTeamIsOpen, loadPage]);

  return (
    <Paper mt={"lg"} withBorder>
      <Title
        order={3}
        ml="sm"
        pt={"md"}
        pl={"sm"}
        pb={"xl"}
        mb={0}
        sx={{ borderBottom: "1px solid #F1F1F1" }}
      >
        <Text mb={"lg"}>Dev Team</Text>
      </Title>
      <Table>
        <thead>
          <tr style={{ backgroundColor: "#f3f3f3" }}>
            <th style={{ width: "150px", padding: "12px", textAlign: "center" }}>Dev Team</th>
            <th style={{ width: "150px", textAlign: "center" }}>Description</th>
            <th style={{ width: "150px", textAlign: "center" }}>Owner</th>
            <th
              style={{
                width: "60px",
                padding: "12px",
                textAlign: "center",
              }}
            ></th>
          </tr>
        </thead>
        <tbody>
          {devTeams &&
            devTeams.map((teams: any) => {
              return (
                <DevTeamRow
                  devTeams={teams}
                  setLoadPage={setLoadPage}
                  loadPage={loadPage}
                  key={teams._id}
                  members={owners}
                  producAreaLoadPage={producAreaLoadPage}
                  setProductAreaLoadPage={setProductAreaLoadPage}
                  loadDevTeams={loadDevTeams}
                  setLoadDevTeams={setLoadDevTeams}
                />
              );
            })}
          {addDevTeamIsOpen === true && (
            <AddDevTeamRow
              setAddDevTeamIsOpen={setAddDevTeamIsOpen}
              setDevTeams={setDevTeams}
              members={owners}
              loadDevTeams={loadDevTeams}
              setLoadDevTeams={setLoadDevTeams}
            />
          )}
        </tbody>
      </Table>
      <Box
        px="xl"
        py="md"
        sx={{
          borderTop: "1px solid #dee2e6",
        }}
      >
        <Button
          bg={"#5C5CEA"}
          sx={{
            fontWeight: 700,
            ":hover": { backgroundColor: "#9f9af8" },
            "&[disabled]": {
              pointerEvents: "all",
              backgroundColor: "#fff",
              cursor: "not-allowed",
              ":hover": {
                backgroundColor: "#fff",
              },
            },
          }}
          color={"#fff"}
          onClick={() => setAddDevTeamIsOpen(true)}
          disabled={addDevTeamIsOpen === true ? true : false}
        >
          + Add Dev Team
        </Button>
      </Box>
    </Paper>
  );
}

export default DevTeam;